function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/* eslint-disable camelcase */
import { CartAdapterBase } from './base';
/**
 * An adapter class to convert a cart model from the Shopify AJAX Cart API to the TrackersJS model.
 * Shopify Cart API: https://shopify.dev/docs/api/ajax/reference/cart
 * @class AjaxCartAdapter
 * @extends CartAdapterBase
 */

export var AjaxCartAdapter = /*#__PURE__*/function (_CartAdapterBase) {
  _inherits(AjaxCartAdapter, _CartAdapterBase);

  var _super = _createSuper(AjaxCartAdapter);

  /**
   * @inheritdoc
   */
  function AjaxCartAdapter(addedCartItems, cart) {
    var _this;

    _classCallCheck(this, AjaxCartAdapter);

    _this = _super.call(this, addedCartItems, cart);

    if (!(cart !== null && cart !== void 0 && cart.total_price)) {
      console.error('AjaxCartAdapter: cart.total_price is missing');
    }

    return _this;
  }
  /**
   * Convert the cart data to an AddToCart event model.
   * @returns {Object} The tracker model, containing cartId, cartUrl and cartItems.
   */


  _createClass(AjaxCartAdapter, [{
    key: "toAddToCartModel",
    value: function toAddToCartModel() {
      var _this$cart$items = this.cart.items,
          cartItems = _this$cart$items === void 0 ? [] : _this$cart$items;

      function findCartItem(item) {
        return cartItems.find(function (cartItem) {
          return cartItem.id === item.id;
        }) || item;
      }

      var value = this.addedCartItems.reduce(function (total, item) {
        var itemInCart = findCartItem(item);
        var price = itemInCart && itemInCart.discounted_price || item.price;
        return total + price * item.quantity / 100.0;
      }, 0);
      var items = this.addedCartItems.map(function (item) {
        var itemInCart = findCartItem(item);
        return _objectSpread(_objectSpread({}, itemInCart), {}, {
          price: (itemInCart.discounted_price || item.price) / 100.0,
          quantity: item.quantity,
          title: itemInCart.product_title,
          variantTitle: itemInCart.variant_title
        });
      });
      return {
        value: value,
        currency: 'USD',
        items: items,
        source: 'shopify',
        rebuildCartUrl: this.getRebuildCartUrl()
      };
    }
    /**
     * Convert the cart data to a Begin Checkout event model.
     */

  }, {
    key: "toBeginCheckoutModel",
    value: function toBeginCheckoutModel() {
      return {
        value: this.cart.total_price / 100.0,
        currency: this.cart.currency || 'USD',
        items: this.cart.items.map(function (item) {
          return {
            item_id: item.variant_id,
            item_name: item.product_title,
            item_variant: item.variant_title
          };
        })
      };
    }
    /**
     * Convert the cart data to an Initiate Checkout event model for Facebook
     */

  }, {
    key: "toInitiateCheckoutModel",
    value: function toInitiateCheckoutModel() {
      var model = this.toAddToCartModel();
      return _objectSpread(_objectSpread({}, model), {}, {
        // prevents the Facebook 'AddToCart' event from being firing by the Facebook Tracker
        fromCart: true
      });
    }
    /**
     * Generator function to iterate over the line items in the cart
     * @returns {Generator<*, void, *>}
     */

  }, {
    key: "lineItemGenerator",
    value:
    /*#__PURE__*/
    regeneratorRuntime.mark(function lineItemGenerator() {
      var _iterator, _step, item;

      return regeneratorRuntime.wrap(function lineItemGenerator$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              // eslint-disable-next-line no-unused-vars
              _iterator = _createForOfIteratorHelper(this.cart.items.reverse());
              _context.prev = 1;

              _iterator.s();

            case 3:
              if ((_step = _iterator.n()).done) {
                _context.next = 9;
                break;
              }

              item = _step.value;
              _context.next = 7;
              return item;

            case 7:
              _context.next = 3;
              break;

            case 9:
              _context.next = 14;
              break;

            case 11:
              _context.prev = 11;
              _context.t0 = _context["catch"](1);

              _iterator.e(_context.t0);

            case 14:
              _context.prev = 14;

              _iterator.f();

              return _context.finish(14);

            case 17:
            case "end":
              return _context.stop();
          }
        }
      }, lineItemGenerator, this, [[1, 11, 14, 17]]);
    })
    /**
     * Get the variant ID for a line item
     * @param item
     * @returns {string}
     */

  }, {
    key: "lineItemVariantId",
    value: function lineItemVariantId(item) {
      return item === null || item === void 0 ? void 0 : item.variant_id;
    }
    /**
     * Get the selling plan ID of a line item.
     * @param item
     * @returns {string}
     */

  }, {
    key: "lineItemSellingPlanId",
    value: function lineItemSellingPlanId(item) {
      var _item$properties;

      return item === null || item === void 0 ? void 0 : (_item$properties = item.properties) === null || _item$properties === void 0 ? void 0 : _item$properties._sellingPlanId;
    }
    /**
     * Generator function to iterate over the line item properties
     * @param item
     * @returns {Generator<{value: *, key: string}, void, *>}
     */

  }, {
    key: "lineItemPropertiesGenerator",
    value:
    /*#__PURE__*/
    regeneratorRuntime.mark(function lineItemPropertiesGenerator(item) {
      var _i, _Object$keys, key;

      return regeneratorRuntime.wrap(function lineItemPropertiesGenerator$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _i = 0, _Object$keys = Object.keys(item.properties);

            case 1:
              if (!(_i < _Object$keys.length)) {
                _context2.next = 8;
                break;
              }

              key = _Object$keys[_i];
              _context2.next = 5;
              return {
                key: key,
                value: item.properties[key]
              };

            case 5:
              _i++;
              _context2.next = 1;
              break;

            case 8:
            case "end":
              return _context2.stop();
          }
        }
      }, lineItemPropertiesGenerator);
    })
    /**
     * Generates key-value pairs for the cart attributes object
     * @param cart
     * @returns {Generator<{value: *, key: string}, void, *>}
     */

  }, {
    key: "cartAttributesGenerator",
    value:
    /*#__PURE__*/
    regeneratorRuntime.mark(function cartAttributesGenerator(cart) {
      var _i2, _Object$keys2, key;

      return regeneratorRuntime.wrap(function cartAttributesGenerator$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _i2 = 0, _Object$keys2 = Object.keys(cart.attributes);

            case 1:
              if (!(_i2 < _Object$keys2.length)) {
                _context3.next = 8;
                break;
              }

              key = _Object$keys2[_i2];
              _context3.next = 5;
              return {
                key: key,
                value: cart.attributes[key]
              };

            case 5:
              _i2++;
              _context3.next = 1;
              break;

            case 8:
            case "end":
              return _context3.stop();
          }
        }
      }, cartAttributesGenerator);
    })
  }]);

  return AjaxCartAdapter;
}(CartAdapterBase);